var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcSevervations = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#141103",
    d: "M15.833 2.5V.833a.833.833 0 1 0-1.666 0V2.5h1.666zM5.833 2.5V.833a.833.833 0 1 0-1.666 0V2.5h1.666zM17.5 19.167h-15a2.5 2.5 0 0 1-2.5-2.5V5.833a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v10.834a2.5 2.5 0 0 1-2.5 2.5zM18.333 7.5H1.667v9.167c0 .46.373.833.833.833h15c.46 0 .833-.373.833-.833V7.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 2.5,
    x: 3.333,
    y: 9.167,
    fill: "#F8D822",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 2.5,
    x: 8.333,
    y: 9.167,
    fill: "#F8D822",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 2.5,
    x: 3.333,
    y: 13.333,
    fill: "#F8D822",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 2.5,
    x: 8.333,
    y: 13.333,
    fill: "#F8D822",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 2.5,
    x: 13.333,
    y: 9.167,
    fill: "#F8D822",
    rx: 0.5
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSevervations, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-severvations.b1a42db2.svg";
export { ForwardRef as ReactComponent };